<template lang="pug">
  .notification-setting-tab
    .mb-3
    NotificationSettingTable(
      v-model="_value"
      :fields="fields"
      :isLoading="isLoading"
      :showText.sync="_showText"
    )

    .register-row(v-show="errorMessage")
      .register-group
        .register-value
          .error-message {{ errorMessage }}

    .box-footer.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons.m-0
        button.btn.update-btn(@click="onUpdateButton" type="button") 更新
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import NotificationSettingTable, { NotificationSettingTableField, NotificationSettingTableItem } from "@/pc/containers/settings/NotificationSettingTable.vue";

/**
 * ### 通知設定タブコンポーネント
 */
@Component({
  components: {
    ValidationAlert,
    NotificationSettingTable
  },
  $_veeValidate: { validator: "new" }
})
export default class NotificationSettingTab extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<NotificationSettingTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<NotificationSettingTableField>;
  /** メッセージで本文を表示するか */
  @Prop({ required: true })
  showText!: boolean;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** エラーメッセージ */
  @Prop({ default: "" })
  errorMessage!: string;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  get _value(): Array<NotificationSettingTableItem> {
    return this.value;
  }

  set _value(newValue) {
    this.$emit("input", newValue);
  }

  get _showText(): boolean {
    return this.showText;
  }

  set _showText(newValue: boolean) {
    this.$emit("update:showText", newValue);
    return;
  }

  /**
   * ### 更新ボタン押下イベント
   *
   * - バリデーションを実施する
   * - バリデーションエラーが無ければ親コンポーネントに更新ボタンイベントを通知する
   */
  public async onUpdateButton(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.$emit("update");
    } else {
      this.showValidationAlert = true;
    }
    return;
  }
}
</script>

<style lang="scss" scoped>
.notification-setting-tab {
  width: 100%;
  overflow: auto;

  .box-footer {
    padding: 10px 0 0 0 !important;
  }

  .update-btn {
    width: 120px;
  }
}
</style>
